module.exports = __webpack_public_path__ + "img/Public Health.8335cebd.jpg";